import { useI18n } from '../i18n/I18nProvider';
import type { RouteName } from '../nav/routes';
import type { TabDef } from '../nav/tabs';
import { ICON_STROKE } from './icons';

/**
 * Нижняя навигация. Набор вкладок приходит параметром, а не берётся внутри компонента,
 * потому что он один на две роли (ТЗ §14.3): кабинет бизнеса передаст сюда `BUSINESS_TABS`,
 * ничего в этом файле не меняя.
 *
 * Пустой набор не рисуется вовсе: полоска без кнопок съедала бы низ экрана и выглядела бы
 * как не загрузившийся элемент.
 */
export function TabBar(props: {
  tabs: readonly TabDef[];
  active: RouteName;
  onSelect: (tab: TabDef) => void;
}): JSX.Element | null {
  const { t } = useI18n();
  if (props.tabs.length === 0) return null;

  return (
    <div className="absolute inset-x-0 bottom-0 z-20 flex border-t border-hair bg-bg pb-[calc(env(safe-area-inset-bottom,0px)+14px)] pt-2">
      {props.tabs.map((tab) => (
        <button
          key={tab.name}
          type="button"
          onClick={() => props.onSelect(tab)}
          aria-current={tab.name === props.active ? 'page' : undefined}
          className={`flex-1 text-center text-[10px] font-semibold transition ${
            tab.name === props.active ? 'text-accent' : 'text-ink-3'
          }`}
        >
          <tab.icon
            className="mx-auto mb-[3px] block"
            size={22}
            strokeWidth={ICON_STROKE}
            aria-hidden="true"
          />
          {t(tab.labelKey)}
        </button>
      ))}
    </div>
  );
}
